import { getSettings } from './store';

const Telegram = window.Telegram;

export type VibrateImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';

export function vibrateImpact(type: VibrateImpactStyle) {
  const settings = getSettings();

  if (!settings.vibration) return;

  try {
    const hapticFeedback = Telegram?.WebApp?.HapticFeedback;
    if (hapticFeedback?.impactOccurred) {
      hapticFeedback.impactOccurred(type);
    }
  } catch (e) {
    console.error("Can't vibrate", e instanceof Error ? e.message : String(e));
  }
}
